import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './authStore';

/** Wymaga zalogowania + rodziny. Bez rodziny → /register-family. Bez usera → /login. */
export function RequireAuthAndFamily() {
  const { user, family, authReady } = useAuthStore();
  const location = useLocation();

  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100 dark:bg-slate-900">
        <div className="w-12 h-12 rounded-full border-4 border-sky-200 dark:border-slate-700 border-t-sky-600 animate-spin" aria-label="Ładowanie..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!family) {
    return <Navigate to="/register-family" replace />;
  }

  return <Outlet />;
}

/** Strony auth: jeśli już zalogowany — wyślij dalej.
 *  Ma rodzinę → /dashboard. Brak rodziny → /register-family (inaczej user
 *  z Google login zostaje na /login bez żadnej akcji). */
export function RedirectIfAuthenticated() {
  const { user, family, authReady } = useAuthStore();

  if (!authReady) return null;
  if (user && family) return <Navigate to="/dashboard" replace />;
  if (user && !family) return <Navigate to="/register-family" replace />;

  return <Outlet />;
}
